import { render, staticRenderFns } from "./BBPendingTransfers.vue?vue&type=template&id=53d5f92d&lang=pug"
import script from "./BBPendingTransfers.vue?vue&type=script&lang=js"
export * from "./BBPendingTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports